module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      height: _vm.height + 'px',
      zIndex: _vm.zIndex
    })
  }, [_c('div', {
    class: _vm.className,
    style: ({
      top: _vm.stickyTop + 'px',
      zIndex: _vm.zIndex,
      position: _vm.position,
      width: _vm.width,
      height: _vm.height + 'px'
    })
  }, [_vm._t("default", [_c('div', [_vm._v("sticky")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36e5b324"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sticky/index.vue
// module id = 1072
// module chunks = 159